<form [formGroup]="eventForm" class="objects-form" style="height:auto; overflow-y: auto;"><!--- (ngSubmit)="onSubmit()"-->
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.huntingEventForm.name' | translate}}</mat-label>
        <input formControlName="name" matInput type="text" required>
        <mat-error *ngIf="eventForm.controls.name.errors?.required">
            {{ 'FORM_VALIDATION.REQUIRED' | translate }}
        </mat-error>
    </mat-form-field>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.huntingEventForm.date' | translate}}</mat-label>
        <input matInput [matDatepicker]="picker1" formControlName="date" readonly>
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1></mat-datepicker>
        <mat-error *ngIf="eventForm.controls.date.errors?.required">
            {{ 'FORM_VALIDATION.REQUIRED' | translate }}
        </mat-error>
    </mat-form-field>

    <mat-slide-toggle class="example-margin slide-toggle-text w-100" formControlName="active">
        {{'FORM.huntingEventForm.active' | translate}}
    </mat-slide-toggle>

    <mat-form-field class="w-100">
        <mat-label>{{'FORM.huntingEventForm.comment' | translate}}</mat-label>
        <textarea formControlName="comment" matInput type="text"></textarea>
    </mat-form-field>
    <mat-form-field class="w-100">
        <mat-label>{{'FORM.huntingEventForm.huntingDistrict' | translate}}</mat-label>
        <mat-select formControlName="huntingDistrict">
            <mat-option *ngFor="let district of data.huntingDistricts" [value]="district">{{district.name}}</mat-option>
        </mat-select>
        <mat-error *ngIf="eventForm.controls.huntingDistrict.errors?.required">
            {{ 'FORM_VALIDATION.REQUIRED' | translate }}
        </mat-error>
    </mat-form-field>
</form>

<div class="sticky-bottom dialog-footer">
    <button [disabled]="eventForm.invalid || submitted" class="second-btn delete-btn" mat-button type="button" (click)="onDelete()">
        {{ 'FORM.BTN_DELETE' | translate }}
    </button>

    <span class="footer-spacer"></span>

    <button class="second-btn" mat-button type="button" (click)="onCancle()">
        {{ 'cancel' | translate }}
    </button>

    <button [disabled]="eventForm.invalid || submitted" class="first-btn" mat-button (click)="onSubmit()">
        {{ 'FORM.BTN_SAVE' | translate }}
    </button>

</div>
